const initialState = {
    reviewData: null,
    reviewDataLoading: false,
    reviewDataError: null,
    pendingReviews: [],
    pendingReviewsLoading: false,
    pendingReviewsError: null
};

export default function reviewReducer(state = initialState, action) {
    switch (action.type) {
        case "REVIEW_DATA_LOADING":
            return {
                ...state,
                reviewDataLoading: action.data
            };
        case "REVIEW_DATA_ERROR":
            return {
                ...state,
                reviewDataError: action.data
            };
        case "REVIEW_DATA_RETRIEVED":
            return {
                ...state,
                reviewData: action.data
            };
        case "PENDING_REVIEWS_LOADING":
            return {
                ...state,
                pendingReviewsLoading: action.data
            };
        case "PENDING_REVIEWS_ERROR":
            return {
                ...state,
                pendingReviewsError: action.data
            };
        case "PENDING_REVIEWS_RETRIEVED":
            return {
                ...state,
                pendingReviews: action.data
            };
        default:
            return state;
    }
} 